import { customFetch } from '../lib/network/Axios';
import { SupportRequest, SupportRequestPriority, SupportRequestStatus } from '../types/supportRequest.types';

export const uploadSupportRequestImage = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('image', file);

  const response = await customFetch.post('/support-requests/attachments', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.url as string;
};

export const createSupportRequest = async (payload: {
  kioskId?: string;
  subject: string;
  description: string;
  priority: SupportRequestPriority;
  attachmentUrls?: string[];
}): Promise<SupportRequest> => {
  const response = await customFetch.post('/support-requests', payload);
  return response.data.request as SupportRequest;
};

export const getMySupportRequests = async (): Promise<SupportRequest[]> => {
  const response = await customFetch.get('/support-requests/mine');
  return response.data.requests as SupportRequest[];
};

export const getAllSupportRequests = async (params?: {
  status?: SupportRequestStatus | '';
  search?: string;
}): Promise<SupportRequest[]> => {
  const response = await customFetch.get('/support-requests', {
    params: {
      status: params?.status || undefined,
      search: params?.search?.trim() || undefined,
    },
  });

  return response.data.requests as SupportRequest[];
};

export const updateSupportRequestStatus = async (
  id: number,
  payload: {
    status: SupportRequestStatus;
    resolutionNote?: string;
    attachmentUrls?: string[];
  },
): Promise<{ request: SupportRequest; notificationRecipient: string }> => {
  const response = await customFetch.patch(`/support-requests/${id}/status`, payload);
  return response.data as { request: SupportRequest; notificationRecipient: string };
};

export const cancelSupportRequest = async (
  id: number,
  payload?: {
    reason?: string;
  },
): Promise<{ request: SupportRequest; notificationRecipient: string }> => {
  const response = await customFetch.patch(`/support-requests/${id}/cancel`, payload || {});
  return response.data as { request: SupportRequest; notificationRecipient: string };
};

export const ownerUpdateSupportRequest = async (
  id: number,
  payload: {
    note: string;
    attachmentUrls?: string[];
  },
): Promise<{ request: SupportRequest; notificationRecipient: string }> => {
  const response = await customFetch.patch(`/support-requests/${id}/owner-update`, payload);
  return response.data as { request: SupportRequest; notificationRecipient: string };
};
